import { BillingDetails } from '../models';

export const MAP_REQUIRED_BILLING_PROPS_TO_TEXT: Omit<BillingDetails, 'address2' | 'state'> = {
  contactFirstName: 'First Name',
  contactLastName: 'Last Name',
  contactEmail: 'Email',
  contactPhoneNumber: 'Phone Number',
  country: 'Country',
  countryCode: 'CO',
  address: 'Address',
  city: 'City',
  zipCode: 'Zip Code',
};
